import * as Sentry from '@sentry/react';

import StoredSentryLog, {
  run_out_of_gas,
  vm_execution_error,
  metamask_header_not_found,
  long_pooling_fetch_api_failed_to_fetch,
  san_api_failed_to_fetch,
  san_api_server_error,
} from 'r/utils/Stored/SentryLog';

function shouldSkip(id) {
  const lastLogTime = StoredSentryLog.get(id);
  if (!lastLogTime) {
    StoredSentryLog.add(id);
    return false;
  }

  if (Date.now() - lastLogTime < 24 * 60 * 60 * 1000) {
    return true;
  }

  StoredSentryLog.add(id);
  return false;
}

export default function captureException(e, extra) {

  if (e.name === 'AbortError') {
    return;
  }

  if (!e.name?.includes('ErrorPage:')) {
    if (e.code === -32000 && e.message === 'header not found') { // https://github.com/MetaMask/metamask-extension/issues/7234
      if (shouldSkip(metamask_header_not_found)) {
        return;
      }
    }

    if (['Failed to fetch', 'NetworkError when attempting to fetch resource.'].includes(e.message) && e.name?.includes('LongPooling: fetchApi')) {
      if (shouldSkip(long_pooling_fetch_api_failed_to_fetch)) {
        return;
      }
    }

    if (e.message === 'Failed to fetch' && e.name?.includes('san_api')) {
      if (shouldSkip(san_api_failed_to_fetch)) {
        return;
      }
    }
    if (e.name?.includes('san_api') && e.message?.includes('server error')) {
      if (shouldSkip(san_api_server_error)) {
        return;
      }
    }
    if (e.name === 'LongPooling: Error' && e.message?.includes('VM execution error. Reverted 0x')) {
      if (shouldSkip(vm_execution_error)) {
        return;
      }
    }

    if (e.name === 'LongPooling: Error' && e.message?.includes('Returned values aren\'t valid, did it run Out of Gas?')) {
      if (shouldSkip(run_out_of_gas)) {
        return;
      }
    }
  }

  console.error(e); // eslint-disable-line no-console

  if (!import.meta.env.VITE_IS_LOCALHOST) {
    Sentry.withScope(scope => {
      if (extra) {
        Object.entries(extra).forEach(
          ([key, value]) => {
            scope.setExtra(key, JSON.stringify(value, (_, value) =>
              typeof value === 'bigint'
                ? value.toString()
                : value,
            ));
          },
        );
      }
      Sentry.captureException(e);
    });
  }
  else {
    if (extra) {
      console.error(extra); // eslint-disable-line no-console
    }
  }
}
